export interface IPaymentMethod {
  payment_types_text: { [key: string]: string }
}
